import React, { useEffect, useState } from "react";
import { NavbarCliente } from "../../dashboardClientes/NavbarCliente";
import { NavbarMobileCliente } from "../../dashboardClientes/NavbarMobileCliente";
import { useAppSelector } from "../../../hooks/hooks";
import Spinner from "../../../components/helpers/Spinner";
import axios from "axios";
import useHeaders from "../../../hooks/useHeaders";
import { set } from "date-fns";
import { ShowDateToUser } from "../../../components/ShowDateToUser";
import Swal from "sweetalert2";

interface Visita {
    id: number;
    fecha: string;
    hora_inicio: string;
    hora_final: string;
    estado: string;
    casa?: {
        id: number;
        nombre: string;
        banner: string;
    };
}

const VisitasCliente = () => {
    const { headers } = useHeaders();
    const { id, tipo_usuario } = useAppSelector(
        (state) => state.usuario_logeado
    );
    console.log(id);
    const [reservas, setReservas] = useState<Visita[]>([]);
    useEffect(() => {
        getVisitas();
    }, [id]);

    const getVisitas = async () => {
        const { data } = await axios.get(
            `${process.env.REACT_APP_PROXY}/visitas_agendadas/getVisitasAgendadasByClient/${id}`,
            { headers }
        );

        setReservas(data.rows);
    };

    const handleEnable = (id_reserva: number) => {
        Swal.fire({
            confirmButtonColor: "#029BFC",
            iconColor: "#029BFC",
            title: "¿Seguro que quieres eliminarlo?",
            text: "Se enviará la reserva a deshabilitados!",
            icon: "warning",
            showCancelButton: true,

            cancelButtonColor: "#d33",
            confirmButtonText: "Si, eliminar!",
            cancelButtonText: "Cancelar",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const { data } = await axios.put(
                        `${process.env.REACT_APP_PROXY}/visitas_agendadas/updateHabilitadoVisitaAgendada/${id_reserva}`,
                        {
                            habilitado: "No",
                            by: "Cliente",
                        },
                        { headers }
                    );
                    Swal.fire({
                        confirmButtonColor: "#029BFC",
                        iconColor: "#029BFC",
                        icon: "success",
                        title: "Reserva elimidada!",
                        showConfirmButton: false,
                        timer: 2000,
                    });
                    getVisitas();
                } catch (error) {
                    console.log(error);
                }
            }
        });
    };

    const render = () => {
        return (
            <div className="w-full">
                <div className="flex flex-col items-start gap-4 px-3 mt-12 sm:px-6 ">
                    <div className="flex items-center justify-center gap-2">
                        <div className="bg-green-500 rounded-full  h-7 w-7"></div>
                        Confirmado por el asesor inmobiliario
                    </div>

                    <div className="flex items-center justify-center gap-2">
                        <div className="bg-orange-500 rounded-full  h-7 w-7"></div>
                        En espera de confirmación
                    </div>
                </div>
                <section className="flex justify-center items-center 2xl:py-[10px] ">
                    <div className="w-full px-11">
                        <div className="flex flex-wrap -mx-8">
                            <div className="w-full ">
                                <div className="flex flex-col">
                                    {true ? (
                                        <div className="w-full ">
                                            <table className="w-full mt-8 overflow-x-auto 2xl:mt-14">
                                                <thead className="text-left border-b-[3px] border-[#CCCCCC] ">
                                                    <tr className="">
                                                        <th className="w-full min-w-[2rem] md:w-1/12 hidden lg:table-cell pb-4 text-center 2xl:text-base text-sm">
                                                            #
                                                        </th>
                                                        <th className="w-full min-w-[8rem] md:w-2/12 hidden lg:table-cell pb-4 text-center 2xl:text-base text-sm">
                                                            Fecha
                                                        </th>
                                                        <th className="w-full min-w-[8rem] md:w-4/12 hidden lg:table-cell pb-4 text-center 2xl:text-base text-sm">
                                                            Casa
                                                        </th>

                                                        <th className="w-full min-w-[10rem] md:w-2/12 pb-4 text-center hidden lg:table-cell 2xl:text-base text-sm">
                                                            Estado
                                                        </th>

                                                        <th className="w-1/12 text-right min-w-[8rem] pr-10 pb-4 2xl:text-base text-sm">
                                                            Acciones
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <div className="my-2 2xl:my-4"></div>
                                                <tbody className="">
                                                    {reservas?.map(
                                                        (reserva, index) => (
                                                            <tr
                                                                key={reserva.id}
                                                                className="w-full text-xs select-none sm:text-sm xl:text-base hover:bg-gray-200">
                                                                <td className="border-r-[3px] border-[#CCCCCC] text-center  ">
                                                                    {index + 1}
                                                                </td>
                                                                <td className="hidden pr-2 text-center lg:table-cell border-r-[3px] border-[#CCCCCC] 2xl:text-base text-sm">
                                                                    <ShowDateToUser
                                                                        date={
                                                                            reserva.fecha
                                                                        }
                                                                    />{" "}
                                                                    {
                                                                        reserva.hora_inicio
                                                                    }
                                                                    {" - "}
                                                                    {
                                                                        reserva.hora_final
                                                                    }
                                                                </td>

                                                                <td className=" text-center lg:table-cell border-r-[3px] border-[#CCCCCC] 2xl:text-base text-sm">
                                                                    <div className="flex items-center justify-center gap-2">
                                                                        <img
                                                                            src={
                                                                                `${process.env.REACT_APP_PROXY}/casa/getImage/` +
                                                                                reserva
                                                                                    ?.casa
                                                                                    ?.banner
                                                                            }
                                                                            alt="icono"
                                                                            className="object-cover rounded-full w-9 h-9 2xl:w-10 2xl:h-10"
                                                                        />{" "}
                                                                        {
                                                                            reserva
                                                                                ?.casa
                                                                                ?.nombre
                                                                        }
                                                                    </div>
                                                                </td>
                                                                <td className=" text-center  lg:table-cell border-r-[3px] border-[#CCCCCC] px-1 2xl:text-base text-sm">
                                                                    <div className="grid grid-cols-[20%,80%] content-center">
                                                                        <div className="flex items-center justify-center">
                                                                            {reserva.estado ===
                                                                            "Agendado" ? (
                                                                                <div className="w-5 h-5 bg-green-500 rounded-full"></div>
                                                                            ) : reserva.estado ===
                                                                              "Por confirmar" ? (
                                                                                <div className="w-5 h-5 bg-orange-500 rounded-full"></div>
                                                                            ) : (
                                                                                <div className="w-5 h-5 bg-red-500 rounded-full"></div>
                                                                            )}
                                                                        </div>
                                                                        <div className="text-left">
                                                                            {
                                                                                reserva.estado
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </td>

                                                                <td className="justify-center py-3 md:flex 2xl:py-5 ">
                                                                    <div className="flex justify-center">
                                                                        <button
                                                                            className="flex items-center justify-center w-8 h-8 px-1 py-1 mx-2 border rounded bg-[#029BFC] text-blue-blueFrom border-[#029BFC] hover:scale-105 group hover:bg-blue-blueFrom hover:text-white"
                                                                            onClick={(
                                                                                e
                                                                            ) => {
                                                                                e.stopPropagation();
                                                                                handleEnable(
                                                                                    reserva.id
                                                                                );
                                                                            }}
                                                                            title="Eliminar">
                                                                            <svg
                                                                                className="w-5 h-5 "
                                                                                id="Capa_2"
                                                                                data-name="Capa 2"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                viewBox="0 0 91.81 100">
                                                                                <g id="Testimonios">
                                                                                    <path
                                                                                        fill="white"
                                                                                        d="m69.32,100H22.49c-.28-.09-.55-.19-.83-.27-5.22-1.49-8.55-4.86-9.37-10.22-.74-4.81-.65-9.72-.96-14.58-.26-3.99-.41-7.98-.63-11.97-.43-7.56-.88-15.11-1.32-22.67-.27-4.74-.54-9.47-.78-14.21-.04-.73-.35-.96-1.03-.94-1.2.03-2.41.04-3.61,0-2.56-.11-4.44-2.66-3.83-5.15.52-2.1,2.14-3.35,4.44-3.36,5.04-.01,10.08-.02,15.12,0,.89,0,1.24-.28,1.19-1.18-.06-1-.02-2.02-.01-3.02C20.88,5.58,26.42.03,33.28.02c8.39-.01,16.78-.04,25.17,0,5.22.03,8.92,2.59,11.31,7.15,1.24,2.37,1.24,4.94,1.2,7.52-.04,1.92,0,1.92,1.88,1.92,4.88,0,9.76-.02,14.63.01,2.49.02,4.38,1.96,4.34,4.34-.04,2.37-1.91,4.15-4.38,4.17-.81,0-1.63,0-2.44,0-1.82,0-1.75-.08-1.8,1.65-.02.49-.11.97-.13,1.46-.33,5.84-.65,11.68-.97,17.52-.39,7.1-.78,14.21-1.17,21.31-.39,7.04-.78,14.08-1.17,21.12-.2,3.61-1.72,6.55-4.42,8.92-1.73,1.52-3.81,2.33-6,2.88ZM45.9,16.62c5.13,0,10.27-.01,15.4.01.84,0,1.18-.27,1.14-1.13-.05-1,0-2.02-.02-3.02-.07-2.18-1.75-3.91-3.93-3.92-8.38-.03-16.77-.03-25.15,0-2.19,0-3.87,1.73-3.94,3.91-.03.94-.01,1.88,0,2.83,0,1.29.03,1.32,1.31,1.32,5.07,0,10.14,0,15.21,0Zm4.04,41.72c0-4,0-8,0-12,0-.45,0-.92-.11-1.35-.49-2.09-2.32-3.32-4.55-3.07-1.9.21-3.4,1.94-3.41,4.01-.01,8.19-.01,16.39,0,24.58,0,2.58,1.75,4.46,4.07,4.42,2.32-.04,3.99-1.86,4-4.4,0-4.06,0-8.13,0-12.19Zm16.61.07s0,0,0,0c0-4.26.03-8.52-.01-12.78-.02-1.92-1.53-3.52-3.36-3.72-2.16-.23-3.98.93-4.5,2.89-.16.6-.21,1.21-.21,1.83,0,4.62,0,9.23,0,13.85,0,3.35-.03,6.7,0,10.05.03,2.96,2.41,4.91,5.09,4.22,1.77-.45,2.96-1.94,2.97-3.86.03-4.16,0-8.32,0-12.48Zm-33.21.01c0-3.93,0-7.87,0-11.8,0-.62-.06-1.24-.22-1.83-.52-1.93-2.27-3.07-4.41-2.88-1.76.16-3.41,1.68-3.42,3.45-.05,8.68-.06,17.36,0,26.04.02,2.19,2.43,3.87,4.58,3.44,2.19-.44,3.43-2,3.45-4.42.02-4,0-8,0-12Z"
                                                                                    />
                                                                                </g>
                                                                            </svg>
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : (
                                        <Spinner />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    };

    return (
        <div>
            <div className="absolute z-[999] flex items-center justify-center w-full text-center"></div>

            {tipo_usuario === 7 && (
                <NavbarCliente>
                    {render()}
                    <NavbarMobileCliente />
                </NavbarCliente>
            )}
        </div>
    );
};

export default VisitasCliente;
